import React from 'react';
import { TfiYoutube } from "react-icons/tfi";
import { SiInstagram } from "react-icons/si";
import { FaFacebookSquare } from "react-icons/fa";

export default function UtsavFooter() {
  return (
    <React.Fragment>
      <>
        <section className="">
          <div className="container mx-auto px-4 py-6 mb-6 md:mb-20 bg-yellow-250 flex flex-col items-center">
            {/* Title at the top */}
            <p className="text-sm text-red-999 font-semibold py-2 my-google-font text-center">
              Social Connect
            </p>

            {/* Logo and Social Icons in a row */}
            <div className="flex flex-row items-center justify-center space-x-4 mt-2">
              <a href="/" className="inline-block text-gray-900 text-lg font-semibold max-h-20">
                <img className="h-7" src="utsav-assets/logo/lus-footer-logo.png" alt="Logo" />
              </a>
              <a className="inline-block w-6" href="">
                <FaFacebookSquare size={24} />
              </a>
              <a className="inline-block w-6" href="">
                <SiInstagram size={20} />
              </a>
              <a className="inline-block w-6" href="">
                <TfiYoutube size={20} />
              </a>
            </div>
          </div>
          <p className="text-center text-sm text-gray-500 pt-4 px-4 border-t">All rights reserved © London Utsav Samithi 2023</p>
        </section>
      </>
    </React.Fragment>
  );
}

